import React from "react";
import { Link } from "react-router-dom";

export default function PrimeButton({
  size = "text-3xl",
  text = "Get A Quote",
  full,
  path = "/contact-us",
  bgColor = "#005CB9",
  bgHover = "bg-blue-800",
  txtColor = "#ffffff"
}) {
  return (
    <Link
      className={`bg-[${bgColor}] hover:${bgHover} focus:ring-4 focus:outline-none focus:ring-blue-300 px-4 text-white dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 ${
        full ? "w-full flex justify-center" : "inline-flex"
      }`}
      to={path}
    >
      <span className={`hookrideFont text-nowrap text-[${txtColor}] ${size} py-1`}>
        {text}
      </span>
    </Link>
  );
}
